import ServerSettings from "../../../gd/settings/server-settings/server-settings";
import {StorageProvider} from "../../../gd/const/storage";

const fieldsConfig = {

    'provider': {
        type            : 'option',
        defaultValue    : StorageProvider.AMAZON_NORTH_AMERICA,
        options         : [
            // StorageProvider.LOCAL, StorageProvider.AMAZON_DEFAULT, StorageProvider.AMAZON_DEV,
            StorageProvider.AMAZON_NORTH_AMERICA, StorageProvider.AMAZON_SOUTH_AMERICA,
            StorageProvider.AMAZON_EUROPE, StorageProvider.AMAZON_ASIA,
        ]
    }

}

export default class CompanySettingsStorage extends ServerSettings {

    public provider     : any

    constructor(config:any) {

        super(config, fieldsConfig);

        this.provider                 = this.initValue('provider')  // default storage provider for uploads
        // this.provider = 0
    }


    toJSON() {
        const result = {};

        this.valueToJson(result, 'provider')

        return result;
    }
}
